<script>

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 10,
    },
    color: {
      type: String,
      default: '#000000de',
    },
  },
  data() {
    return {
      $value: `${this.value}`,
      propsColor: this.color,
    };
  },
  methods: {
    update(value) {
      this.$data.$value = value;
    },
  },
  watch: {
    '$data.$value': function update(value) {
      this.$emit('input', Number(value));
    },
  },
  computed: {
    percent() {
      const range = this.max - this.min;
      const value = this.value ? (this.value - this.min) : 0;
      return Math.round((value / range) * 100);
    },
  },
  mounted() {
    // IE autofill fix
    setTimeout(() => {
      if (this.$refs.input?.value) {
        this.$refs.input.value = this.$data.$value;
      }
    }, 120);
  },
};
</script>

<template lang="pug">
div(:class="[$style.root, percent === 0 && $style.min]")
  input(:class="$style.input",
    type="range",
    ref="input",
    :step="step",
    :min="min",
    :max="max",
    :value="value ? value : min",
    :data-percent="percent",
    @input="update($event.target.value)",
    @change="update($event.target.value)")
</template>

<style module lang="sass">

.root
  height: 18px
  position: relative
  cursor: pointer
  color: $color_main
.min
  color: $color_text_second_dark
  color: red
.input
  position: absolute
  overflow: visible
  top: 0
  left: 0
  bottom: 0
  right: 0
  display: block
  width: 100%
  outline: none
  -webkit-appearance: none
  appearance: none
  border-radius: 0
  margin: 0
  padding: 0
  cursor: pointer
  &::-webkit-slider-runnable-track
    width: 100%
    height: 2px
    cursor: pointer
    animation-duration: $a_speed
    background-color: v-bind(propsColor)
    color: v-bind(propsColor)
    transition: background $a_speed
    border: none
  &::-moz-range-track
    width: 100%
    height: 2px
    cursor: pointer
    animation-duration: $a_speed
    background-color: $color_text_second_dark
    transition: background $a_speed
    border: none
  &::-moz-range-progress
    width: 100%
    height: 2px
    background-color: v-bind(propsColor)
    border: none
  &::-ms-track
    background: transparent
    border-color: transparent
    color: transparent
    animation-duration: $a_speed
  &::-ms-fill-lower
    height: 2px
    cursor: pointer
    background-color: $color_main
    border: none
  &::-ms-fill-upper
    height: 2px
    cursor: pointer
    background-color: $color_text_second_dark
    border: none
  &::-webkit-slider-thumb
    border: none
    height: 12px
    width: 12px
    background-color: currentColor
    margin-top: -5px
    cursor: pointer
    -webkit-appearance: none
    appearance: none
    border-radius: 50%
    transition: transform $a_speed, color $a_speed
    box-sizing: content-box
  &::-moz-range-thumb
    border: none
    height: 12px
    width: 12px
    background: v-bind(propsColor)
    cursor: pointer
    appearance: none
    border-radius: 50%
    transition: transform $a_speed, color $a_speed
    box-sizing: content-box
  &::-ms-thumb
    height: 12px
    width: 12px
    border: 3px solid transparent
    background: v-bind(propsColor)
    margin-top: 0px
    cursor: pointer
    appearance: none
    border-radius: 50%
    background-clip: content-box
    transition: transform $a_speed, color $a_speed
    box-sizing: content-box
  &:focus::-webkit-slider-thumb
    transform: scale(1.3)
  .root:hover &::-webkit-slider-thumb
    color: $color_main
    transform: scale(1.5)
  &:focus::-moz-range-thumb
    transform: scale(1.3)
  .root:hover &::-moz-range-thumb
    color: $color_main
    transform: scale(1.5)
  &:focus::-ms-thumb
    transform: scale(1)
  .root:hover &::-ms-thumb
    color: $color_main
    border: none
    height: 18px
    width: 18px
    transform: scale(1)

@for $i from 1 through 100
  .input[data-percent=\"#{$i}\"]::-webkit-slider-runnable-track
    background-image: linear-gradient(to right, $color_main 0%, $color_main $i + '%', $color_text_second_dark $i + '%', $color_text_second_dark 100%)
</style>
